import RedecredenciadaPlanCategory from "@/pages/redecredenciada/iframe/plan-category.vue";
import BuscaDeRede from "@/pages/redecredenciada/iframe/index.vue";
import TypeStablishment from "@/pages/redecredenciada/iframe/type-stablishment.vue";
import Specialities from "@/pages/redecredenciada/iframe/specialities.vue";
import Location from "@/pages/redecredenciada/iframe/location.vue";
import AccreditedList from "@/pages/redecredenciada/iframe/accredited-list.vue";
import DoctorDetail from "@/pages/redecredenciada/iframe/doctor-detail.vue";
import PlansServed from "@/pages/redecredenciada/iframe/plans-served.vue";

const routes: Route[] = [
  {
    path: "/busca-de-rede",
    redirect: "/busca-de-rede/planos",
    component: BuscaDeRede,
    meta: {
      allowAnonymous: true
    },
    children: [
      {
        path: "plano",
        name: "network.plan",
        component: RedecredenciadaPlanCategory,
        meta: {
          allowAnonymous: true
        }
      },
      {
        path: "busca",
        name: "network.search",
        component: TypeStablishment,
        meta: {
          allowAnonymous: true
        }
      },
      {
        path: "especialidades",
        name: "network.specialities",
        component: Specialities,
        meta: {
          allowAnonymous: true
        }
      },
      {
        path: "localizacao",
        name: "network.location",
        component: Location,
        meta: {
          allowAnonymous: true
        }
      },
      {
        path: "credenciados",
        name: "network.accredited.list",
        component: AccreditedList,
        meta: {
          allowAnonymous: true
        }
      },
      {
        path: "detalhes",
        name: "network.doctor.detail",
        component: DoctorDetail,
        meta: {
          allowAnonymous: true
        }
      },
      {
        path: "planos-atendidos",
        name: "network.plans.served",
        component: PlansServed,
        meta: {
          allowAnonymous: true
        }
      }
    ]
  }
];
export default routes;
